import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import TotalAlumnos from './TotalAlumnos';
import { toGetCounterAlumnos } from 'data/apiConection.js/dataAlumnos';
import { toCounterCursos } from 'data/apiConection.js/dataCursos';

const Home = () => {
  const [counterAlumnos, setCounterAlumnos] = useState({ total_alumnos: 0 });
  const [counterCursos , setCounterCursos ] = useState({ total_cursos: 0});
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCounterAlumnos = async () => {
      try {
        const counter = await toGetCounterAlumnos('2025');
        if (counter) {
          setCounterAlumnos(counter);
        }
      } catch (error) {
        console.error(error);
        setError("Error al cargar el número de alumnos.");
      }
    };
    fetchCounterAlumnos();
  }, []);
  useEffect(()=>{
    const fetchCounterCursos = async () => {
      try {
         const counterCu = await toCounterCursos();
         if(counterCu){
          setCounterCursos(counterCu);
         }
      } catch (error) {
        console.error(error);
        setError("Error al cargar el número de Cursos.");
      }    
    }
    fetchCounterCursos();
  },[])

  return (
    <>
      <Row className="g-3 mb-3">
        <Col md={6} xxl={3}>
          <TotalAlumnos
            number={counterAlumnos.total_alumnos} 
            titleCard="Alumnos"
            error={error} 
          />
        </Col>
        <Col md={6} xxl={3}>
          <TotalAlumnos number={counterCursos.total_cursos} titleCard="Cursos" />
        </Col>
      </Row>
    </>
  );
};

export default Home;
